import React from 'react';
import { Link } from 'react-router-dom';
import { useAdminData } from '../../contexts/AdminDataContext';
import { CONTACT_EMAIL, company } from '../../data/site';
import { telHref } from '../../utils/format';
export function Footer() {
  const {
    settings
  } = useAdminData();
  return <footer className="border-t border-line bg-canvas-deep" data-id="element-339" data-mp="31es11lyi0scv">
      <div className="mx-auto max-w-content px-5 py-12 lg:px-8" data-id="element-340" data-mp="31fa5v6z88ewe">
        <div className="flex flex-col gap-10 md:flex-row md:justify-between" data-id="element-341" data-mp="3p5nok6vx91eb">
          <div data-id="element-342" data-mp="3u47cudxzmp9u">
            <img src={company.logoWide} alt={settings.companyName} className="h-12 w-auto md:h-14" data-id="element-343" data-mp="3u2nv0iwoo65y" />
            <p className="mt-4 text-[15px] text-ink-soft" data-id="element-344" data-mp="3fdrr8y1ntfb5">{settings.tagline}</p>
            <p className="mt-4 text-sm text-ink-muted" data-id="element-345" data-mp="3kdcnv1tcxbkp">CVR: {settings.cvr}</p>
          </div>

          <div className="flex flex-col gap-2 text-[15px] md:items-end" data-id="element-346" data-mp="bycfnsdmuxnw">
            {settings.phone && <a href={telHref(settings.phone)} className="text-ink transition-colors duration-200 ease-smooth hover:text-accent" data-id="element-347" data-mp="gpaxwxi6m5ts">
                {settings.phone}
              </a>}
            <a href={`mailto:${CONTACT_EMAIL}`} className="text-ink transition-colors duration-200 ease-smooth hover:text-accent" data-id="element-348" data-mp="3eicjhqf8b4f1">
              {CONTACT_EMAIL}
            </a>
            <div className="mt-3 flex gap-5 text-sm text-ink-muted" data-id="element-349" data-mp="3nfd21gfma8ak">
              <a href="#kontakt" className="transition-colors duration-200 ease-smooth hover:text-ink" data-id="element-350" data-mp="5z4xhugxt3mb">
                Kontakt
              </a>
              <a href="#privatliv" className="transition-colors duration-200 ease-smooth hover:text-ink" data-id="element-351" data-mp="f1eaqs3lbb3e">
                Privatlivspolitik
              </a>
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-wrap items-center justify-between gap-3 border-t border-line pt-6 text-sm text-ink-muted" data-id="element-352" data-mp="2gshi98i6o9jq">
          <p data-id="element-353" data-mp="2cs7em2hv5v81">
            © {new Date().getFullYear()} {settings.companyName}
          </p>
          <Link to="/admin/login" className="transition-colors duration-200 ease-smooth hover:text-ink" data-id="element-354" data-mp="frl2t9xjuras">
            Admin
          </Link>
        </div>
      </div>
    </footer>;
}